// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OqZ1","colMin":"styles_colMin__GCJ34"};